import RangeIterator from './RangeIterator'

const cronRegexps = {
  // eslint-disable-next-line no-useless-escape
  minutes: /(\*|((\*\/)?[1-5]?[0-9])|(?:(([1-5]?[0-9])(?:\,[1-5]?[0-9])*)*)|([1-5]?[0-9]\-[1-5]?[0-9]))/,
  // eslint-disable-next-line no-useless-escape
  hours: /(\*|((\*\/)?(1?[0-9]|2[0-3]))|(?:((1?[0-9]|2[0-3])(?:\,(1?[0-9]|2[0-3]))*)*)|((1?[0-9]|2[0-3])\-(1?[0-9]|2[0-3])))/,
  // eslint-disable-next-line no-useless-escape
  days: /(\*|((\*\/)?([1-9]|[12][0-9]|3[0-1]))|(?:([1-9]|[12][0-9]|3[0-1]))+(?:\,([1-9]|[12][0-9]|3[0-1]))*|(([1-9]|[12][0-9]|3[0-1])\-([1-9]|[12][0-9]|3[0-1])))/,
  // eslint-disable-next-line no-useless-escape
  months: /(\*|((\*\/)?([1-9]|1[0-2]))|(?:([1-9]|1[0-2])+(?:\,([1-9]|1[0-2]))*)|(([1-9]|1[0-2])\-([1-9]|1[0-2])))/,
  // eslint-disable-next-line no-useless-escape
  weekdays: /(\*|((\*\/)?[0-7])|((?:[0-7])+(?:\,[0-7])*)|([0-7]\-[0-7]))/
}

const minutesRange = () => {
  const presets = [
    { value: '', text: '-- Common settings --', disabled: true },
    { value: '*', text: '* - one per minute' },
    { value: '*/2', text: '*/2 - every other minute' },
    { value: '*/5', text: '*/5 - every 5 minutes' },
    { value: '*/10', text: '*/10 - every 10 minutes' },
    { value: '*/15', text: '*/15 - every 15 minutes' },
    { value: '0,30', text: '0,30 - every 30 minutes' }
  ]
  const minutes = [...(new RangeIterator(0, 59))]
  return [
    ...presets,
    ...minutes.map(minute => ({ ...minute, text: `${minute.value}` }))
  ]
}

// Convert hour to AM/PM format: 14 => 02:00 p.m.
const amPmFormatter = (hour) => {
  const amPmHour = (hour !== 0 ? (hour > 12 ? hour - 12 : hour) : 12).toString()
  const amPm = hour > 12 ? 'p.m.' : 'a.m.'
  return `${amPmHour.length > 1 ? amPmHour : '0' + amPmHour}:00 ${amPm}`
}

const hoursRange = () => {
  const presets = [
    { value: '', text: '-- Common settings --', disabled: true },
    { value: '*', text: '* - every hour' },
    { value: '*/2', text: '*/2 - every other hour' },
    { value: '*/3', text: '*/3 - every 3rd hour' },
    { value: '*/4', text: '*/4 - every 4th hour' },
    { value: '*/6', text: '*/6 - every 6th hour' },
    { value: '0,12', text: '0,12 - every 12 hours' }
  ]
  const hours = [...(new RangeIterator(0, 23))]
  return [
    ...presets,
    ...hours.map(hour => ({ ...hour, text: `${hour.value} - ${amPmFormatter(hour.value)}` }))
  ]
}

// Get suffix by day number: 1 => st, 3 => rd, etc.
const dayOrdinalSuffix = (dayNumber) => {
  const suffixes = ['th', 'st', 'nd', 'rd']
  const check = dayNumber % 100 // convert
  return suffixes[(check - 20) % 10] || suffixes[check] || suffixes[0]
}

const daysRange = () => {
  const presets = [
    { value: '', text: '-- Common settings --', disabled: true },
    { value: '*', text: '* - every day' },
    { value: '*/2', text: '*/2 - every other day' },
    { value: '1,15', text: '1,15 - on the 1st and the 15th of the month' }
  ]
  const days = [...(new RangeIterator(1, 31))]
  return [
    ...presets,
    ...days.map(day => ({ ...day, text: `${day.value} - ${day.value}${dayOrdinalSuffix(day.value)}` }))
  ]
}

// Get month name by number
const monthName = (number) => {
  const names = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
  return names[number - 1] || ''
}

const monthsRange = () => {
  const presets = [
    { value: '', text: '-- Common settings --', disabled: true },
    { value: '*', text: '* - every month' },
    { value: '*/2', text: '*/2 - every other month' },
    { value: '*/4', text: '*/4 - every third month' },
    { value: '1,7', text: '1,7 - every six month' }
  ]
  const months = [...(new RangeIterator(1, 12))]
  return [
    ...presets,
    ...months.map(month => ({ ...month, text: `${month.value} - ${monthName(month.value)}` }))
  ]
}

// Get weekday name
const weekdayName = (number, firstDayOfWeek = 'Sunday') => {
  const names = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
  const firstDay = names.indexOf(firstDayOfWeek) !== -1 ? names.indexOf(firstDayOfWeek) : 0
  const actualNames = [...names.slice(firstDay, names.length - firstDay), ...names.slice(0, firstDay)]
  // actualNames contains weekdays names accordingly to the first day of week
  return actualNames[number - 1] || ''
}

const weekdaysRange = () => {
  const presets = [
    { value: '', text: '-- Common settings --', disabled: true },
    { value: '*', text: '* - every day' },
    { value: '1-5', text: '1-5 - every weekday' },
    { value: '6,0', text: '6,0 - every weekend day' },
    { value: '1,3,5', text: '1,3,5 - every Monday, Wednesday and Friday' },
    { value: '2,4', text: '2,4 - every Tuesday and Thursday' }
  ]
  const weekdays = [...(new RangeIterator(0, 6))]
  const firstDayOfWeek = 'Sunday' // crontab first day of week - Sunday
  return [
    ...presets,
    ...weekdays.map(weekday => ({ ...weekday, text: `${weekday.value} - ${weekdayName(weekday.value + 1, firstDayOfWeek)}` }))
  ]
}

const presetsRange = [
  { value: '', text: '-- Common settings --', disabled: true },
  { value: '* * * * *', text: '* * * * * - Once per minute' },
  { value: '*/5 * * * *', text: '*/5 * * * * - Once per five minutes' },
  { value: '*/15 * * * *', text: '*/5 * * * * - Once per fifteen minutes' },
  { value: '0,30 * * * *', text: '0,30 * * * * - Twice per hour' },
  { value: '0 * * * *', text: '0 * * * * - Once per hour' },
  { value: '0 0,12 * * *', text: '0 0,12 * * * - Twice per day' },
  { value: '0 0 * * *', text: '0 0 * * * - Once per day' },
  { value: '0 0 * * 0', text: '0 0 * * 0 - Once per week' },
  { value: '0 0 1,15 * *', text: '0 0 1,15 * * - On the 1st and 15th of the Month' },
  { value: '0 0 1 * *', text: '0 0 1 * * - Once per month' },
  { value: '0 0 1 1 *', text: '0 0 1 1 * - Once per year' }
]

const validateCronString = (str) => {
  const regex = new RegExp('^' +
    cronRegexps.minutes.source + ' ' +
    cronRegexps.hours.source + ' ' +
    cronRegexps.days.source + ' ' +
    cronRegexps.months.source + ' ' +
    cronRegexps.weekdays.source + '$')
  return str.match(regex)
}

// Converts string "* * * * *" to object {minute: '*', hour: '*', day: '*', month: '*', weekday: '*'}
const parseCronString = (str) => {
  const cronParts = str.split(' ')
  const cronPartsNames = ['minute', 'hour', 'day', 'month', 'weekday']
  if (!validateCronString(str)) {
    return null
  }
  return cronParts.reduce((carry, part, index) => {
    carry[cronPartsNames[index]] = part
    return carry
  }, {})
}

// Converts cron object to string
const cronObjectToString = (obj) => {
  return `${obj.minute} ${obj.hour} ${obj.day} ${obj.month} ${obj.weekday}`
}

export {
  presetsRange,
  weekdaysRange,
  monthsRange,
  daysRange,
  hoursRange,
  minutesRange,
  parseCronString,
  validateCronString,
  cronObjectToString,
  cronRegexps,
}
